import { render, staticRenderFns } from "./LibraryMenuFilters.vue?vue&type=template&id=24bae08a&"
import script from "./LibraryMenuFilters.vue?vue&type=script&lang=ts&"
export * from "./LibraryMenuFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports